// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Combos_EstornarResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract de POST /so/combos/estornar (NS 2026-0090, fatia 5).
 *
 * O estorno gravado (`movement_id`), o consumo que ele devolve
 * (`origin_movement_id`) e o saldo da compra DEPOIS dele.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Combos_EstornarResponseDados {
combo_purchase_id: number
movement_id: number
origin_movement_id: number
quantidade: number
reservado: number
consumido: number
disponivel: number
}

export type Combos_EstornarResponse = ApiResponse<Combos_EstornarResponseDados>;

registerResponseContract('Combos_EstornarResponse', {
  combo_purchase_id:  { type: 'number',  required: true },
  movement_id:        { type: 'number',  required: true },
  origin_movement_id: { type: 'number',  required: true },
  quantidade:         { type: 'number',  required: true },
  reservado:          { type: 'number',  required: true },
  consumido:          { type: 'number',  required: true },
  disponivel:         { type: 'number',  required: true },
})
